import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Users, Building } from 'lucide-react';

const MutualConnectionsModal = ({ isOpen, onClose, connections, providerName }) => {
  if (!connections || connections.length === 0) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Users className="w-5 h-5" style={{color: 'var(--brand-navy)'}} />
            <span style={{color: 'var(--brand-navy)'}}>
              Shared Connections
            </span>
          </DialogTitle>
          <p className="text-sm text-gray-600">
            {connections.length} people in your network also know {providerName}
          </p>
        </DialogHeader>
        
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {connections.map((connection, index) => (
            <div key={index} className="flex items-center gap-3 p-3 rounded-lg border hover:bg-gray-50 transition-colors">
              <div 
                className="w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold"
                style={{background: 'linear-gradient(135deg, var(--brand-navy) 0%, var(--brand-navy-light) 100%)'}}
              >
                {connection.name.charAt(0).toUpperCase()}
              </div>
              <div className="flex-1">
                <div className="font-medium text-gray-900">
                  {connection.name}
                </div>
                {connection.company && (
                  <div className="flex items-center gap-1 text-sm text-gray-500">
                    <Building className="w-3 h-3" />
                    {connection.company}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        
        <div className="pt-4 border-t">
          <p className="text-xs text-gray-500 text-center">
            These are people in your network who also know {providerName}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MutualConnectionsModal;